export const unique = (entities: any, param: string) => {
  return entities.filter((obj: any, pos: any, arr: any) => {
    return arr.map((mapObj: any) => mapObj[param]).indexOf(obj[param]) === pos;
  });
};

export const checkUserPermissions = (userRole: string, roles: string[]) => {
  return roles.includes(userRole);
};
export const checkDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
  ) {
    return "mobile";
  }
  return "desktop";
};

export const attachNavigationWarning = () => {
  if (!window.onbeforeunload) {
    window.onbeforeunload = () => true;
  }
};

export const deattachNavigationWarning = () => (window.onbeforeunload = null);

export const mapOptionsToRangeLabels = (options: string[], step?: number): Record<string, string> => {
  if (step === 1) {
    return options.reduce((a, v, i) => ({ ...a, [i]: v }), {});
  } else {
    // step is 0.25 (default)
    return options.reduce((acc, v, index, arr) => {
      if (index === arr.length - 1) {
        acc[index] = v;
      } else {
        acc[index] = v;
        acc[index + 0.25] = "";
        acc[index + 0.5] = "";
        acc[index + 0.75] = "";
      }
      return acc;
    }, {});
  }
};
